import { ErrorHandler, inject, Injectable, Provider } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NGX_LOGGER_CONFIG, NGX_LOGGER_LEVELS, NgxLoggerErrorHandler, NgxLoggerService } from '@allianz/ngx-logger';
import { UserService } from 'shared-data-access';
import { Router } from '@angular/router';
import { ApplicationConfig } from 'shared-utils';
import { CustomLoggerInterceptor } from './custom-logger.interceptor';

export const provideLogger = (environment: ApplicationConfig): Provider[] => {
  if (!environment.production || !environment.loggerUrl) {
    return [];
  }

  return [
    {
      provide: NGX_LOGGER_CONFIG,
      useValue: {
        console: {
          level: NGX_LOGGER_LEVELS.DEBUG,
          appendLevel: true,
          appendTimestamp: true,
        },
        server: {
          level: NGX_LOGGER_LEVELS.DEBUG,
          appName: 'portal-fe',
          endpoint: environment.loggerUrl,
        },
      },
    },
    {
      provide: NgxLoggerService,
      useClass: CustomLoggerService,
    },
    {
      provide: ErrorHandler,
      useClass: NgxLoggerErrorHandler,
      deps: [NgxLoggerService],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomLoggerInterceptor,
      multi: true,
    },
  ];
};

@Injectable()
// @ts-expect-error private method
class CustomLoggerService extends NgxLoggerService {
  private readonly userService = inject(UserService);
  private readonly router = inject(Router);

  private logToServer(level: NGX_LOGGER_LEVELS, msg: string, ...params: unknown[]) {
    const additionalInformation: Record<string, unknown> = {
      provider: this.userService.getProviderId(),
      country: this.userService.getCountry(),
      userType: this.userService.getType(),
      routerUrl: this.router.url,
    };
    // @ts-expect-error private method
    super.logToServer(level, msg, additionalInformation, ...params);
  }
}
